import { Action } from 'redux';
import IApplicationEmail from '~Api/ApplicationEmail/IApplicationEmail';
import ApplicationEmailsActionsEnum from './ActionsEnum';

export interface IApplicationEmailsListAction extends Action {
    applicationUuid: string;
    pageNumber: number;
    perPage: number;
}

export function applicationEmailsListAction(
    applicationUuid: string,
    pageNumber: number,
    perPage: number,
): IApplicationEmailsListAction {
    return {
        applicationUuid,
        pageNumber,
        perPage,
        type: ApplicationEmailsActionsEnum.ApplicationEmailsList,
    };
}

export interface IApplicationEmailsSetAction extends Action {
    applicationUuid: string;
    count: number;
    emails: IApplicationEmail[];
}

export function applicationEmailsSetAction(
    applicationUuid: string,
    emails: IApplicationEmail[],
    count: number,
): IApplicationEmailsSetAction {
    return {
        applicationUuid,
        count,
        emails,
        type: ApplicationEmailsActionsEnum.ApplicationEmailsSet,
    };
}

export interface IApplicationEmailTextGetAction extends Action {
    applicationEmailUuid: string;
}

export function applicationEmailTextGetAction(
    applicationEmailUuid: string,
): IApplicationEmailTextGetAction {
    return {
        applicationEmailUuid,
        type: ApplicationEmailsActionsEnum.ApplicationEmailTextGet,
    };
}

export interface IApplicationEmailTextSetAction extends Action {
    applicationEmailUuid: string;
    text: string;
}

export function applicationEmailTextSetAction(
    applicationEmailUuid: string,
    text: string,
): IApplicationEmailTextSetAction {
    return {
        applicationEmailUuid,
        text,
        type: ApplicationEmailsActionsEnum.ApplicationEmailTextSet,
    };
}
